import { render, staticRenderFns } from "./addMemberToWorkflow.vue?vue&type=template&id=0c56890e&scoped=true"
import script from "./addMemberToWorkflow.vue?vue&type=script&lang=js"
export * from "./addMemberToWorkflow.vue?vue&type=script&lang=js"
import style0 from "./addMemberToWorkflow.vue?vue&type=style&index=0&id=0c56890e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c56890e",
  null
  
)

export default component.exports